// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"197":"1df096d8c19cb5f8","352":"a569d654a8539284"}[chunkId] + ".js";
};